import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import ShellProfileOverlay from "components/v2/shell-profile-overlay/ShellProfileOverlay";
import HomeStub from "pages/home/HomeStub";

const HomeShellLayout = () => {
  return (
    <GlobalNavigationShell notificationsEnabled={false} navSlotPlacement="none" shellContext="home">
      <ShellProfileOverlay>
        <HomeStub />
      </ShellProfileOverlay>
    </GlobalNavigationShell>
  );
};

export default HomeShellLayout;
